import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { Itinerante } from "../../../../services/Itinerante";

export const useItinerantePorId = (uuidItinerante: string) => {
  const query = useQuery({
    queryKey: ["itinerante-por-id", uuidItinerante],
    queryFn: () => Itinerante.byId(uuidItinerante),
    select: (response) => response.data,
    enabled: !!uuidItinerante,
  });

  useEffect(() => {
    if (!query.isError) return;

    const {
      response: {
        data: { mensagem },
      },
    } = query.error as any;

    toast.error(mensagem);
  }, [query.isError]);

  return query;
};
